export default __webpack_public_path__ + "static/media/INREALTIME.67bf53e2.jpg";